module.exports = __webpack_public_path__ + "static/media/dynamic_segments_sparkle_gradient.a7d23d64.svg";